var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-section statistics-data"},[(_vm.dataType === 0)?_c('StatisticsTreatmentsData'):_vm._e(),(_vm.dataType === 1)?_c('StatisticsDoctorsData'):_vm._e(),_c('StatisticsExport')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }